module.exports = __webpack_public_path__ + "static/img/200303.c1903859.png";